import { useEffect, useRef } from 'react'
import cx from 'classnames'
import { EditorState } from 'prosemirror-state'
import { EditorView } from 'prosemirror-view'
import { Schema } from 'prosemirror-model'
import { useEditorFonts } from 'hooks/useEditorFonts/useEditorFonts'
import { useFadingScrollbar } from 'hooks/useFadingScrollbar'
import Styles from './ProseInput.module.scss'
import { schema as defaultSchema } from './Schema'
import { parseHTMLStringToFragment } from 'proseShared/utils'
import { nodeViews } from './nodeViews'

interface Props {
  className?: string
  html: string
  schema?: Schema
}

/**
 * Used to display html generated with the `ProseInput` component.
 * The `ProsePreview` component uses the neruda schema nodeviews, which could be problematic
 * when viewing content created with the `ProseInput` component, due to the two different
 * prosemirror schemas.
 */
export const ProseDisplay = ({ className, html, schema = defaultSchema }: Props) => {
  const ref = useRef<HTMLDivElement>(null)
  useFadingScrollbar(ref.current)

  useEditorFonts()

  useEffect(() => {
    if (!ref.current) return
    const nodes = parseHTMLStringToFragment(html, schema)
    const doc = schema.nodes.doc.create({}, nodes)
    const state = EditorState.create({ doc })

    const editorView = new EditorView(ref.current, {
      state,
      nodeViews,
      editable: () => false,
      attributes: {
        class: Styles.proseDisplay,
      },
    })

    return () => editorView.destroy()
  }, [html, schema])

  return <div className={cx(className, 'prose-display', Styles.proseInput)} ref={ref} />
}
